import type { QuestionTextModel } from '@psyomics/surveyjs-core';
import { format, isValid, parse } from 'date-fns';
import React from 'react';

import { PatientDatePicker } from '../../../../components/atoms/date-picker/patient-date-picker';

const DATE_FORMAT = 'yyyy-MM-dd';

const datePickerWidget = {
  isDefaultRender: false,
  isFit: (question: QuestionTextModel) => question.getType() === 'text' && question.inputType === 'date',
  name: 'date-picker',
  render: (question: QuestionTextModel) => {
    if (question.isReadOnlyRenderDiv()) {
      return <div>{question.inputValue}</div>;
    }

    const parsedDate = parse(question.inputValue ?? '', DATE_FORMAT, new Date());

    return (
      <PatientDatePicker
        ariaLabelledby={question.a11y_input_ariaLabelledBy}
        captionLayout="dropdown-buttons"
        date={isValid(parsedDate) ? parsedDate : undefined}
        fromYear={1900}
        id={question.inputId}
        setDate={(nextDate) => {
          const formattedDate = nextDate ? format(nextDate, DATE_FORMAT) : '';
          question.inputValue = formattedDate;
          question.onChange({ target: { value: formattedDate } });
        }}
        toYear={new Date().getFullYear()}
      />
    );
  },
};

export { datePickerWidget };
